<template>
  <div class="content-header">
    <img :src="img" v-if="img!==''" />
    <div>
      <h2 v-html="title"></h2>
    </div>
  </div>
</template>

<script>
import qImg from '../assets/images/q_icon.png';
import cImg from '../assets/images/c_icon.png';
import ccImg from '../assets/images/cc_icon.png';
export default {
  name: "SectionTitle",
  props:{
    icon:{
      type:String,
      default:''
    },
    title:{
      type:String,
      default:''
    }
  },
  data(){
    return {
      img:"",
      small:"",
    }
  },
  created() {
    if(this.$slots.default !== undefined) {
      this.title = this.$slots.default[0].text.replace('[','<span>').replace(']','</span>');
    }
  },
  watch:{
    icon:{
      handler(newVal){
        switch (newVal){
          case 'Q':
            this.img =  qImg;
            break;
          case 'C':
            this.img = cImg;
            break;
          case 'CC':
            this.img = ccImg;
            break;
        }
      },
      deep:true,
      immediate:true
    },
  },
}
</script>

<style scoped>

</style>
